import { listenerMiddleware } from './listenerMiddleware';
import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from '@reduxjs/toolkit';
import viewReducer from '../features/view/viewSlice';
import authReducer from '../features/auth/authSlice';
import sitesReducer from '../features/sites/sitesSlice';
import controllersReducer from '../features/controllers/controllersSlice';
import { api, rtkQueryErrorLogger } from '../app/services/api'; // importing this before the slice reducers causes a issue with api

export const rootReducer = combineReducers({
  view: viewReducer,
  auth: authReducer,
  sites: sitesReducer,
  controllers: controllersReducer,
  [api.reducerPath]: api.reducer,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const resetStoreMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action);

  if (action.type === 'auth/logout') {
    // Reset the entire store to initial state
    store.dispatch({ type: '@@INIT' });
    // Also clear RTK Query cache
    store.dispatch(api.util.resetApiState());
  }

  return result;
};

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        serializableCheck: false,
      }).concat(
        listenerMiddleware.middleware,
        resetStoreMiddleware,
        api.middleware,
        rtkQueryErrorLogger,
      );
    },
    preloadedState,
    devTools: true,
  });
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      listenerMiddleware.middleware,
      resetStoreMiddleware,
      api.middleware,
      rtkQueryErrorLogger,
    );
  },
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const selectState = (state: RootState) => state;
